import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import ProfileMain from '../pages/profile/ProfileMain';
import Navbar from '../components/Navbar';

const Stack = createStackNavigator();

export default function ProfileRoute() {
  return (
    <Stack.Navigator 
      initialRouteName="ProfileMain"
      screenOptions={{
        header: ({ navigation }) => (
          <Navbar navigation={navigation} />
        ),
      }}
    >
      <Stack.Screen name="ProfileMain" component={ProfileMain} />
    </Stack.Navigator>
  );
};